module.exports = __webpack_public_path__ + "media/images/web/landings/students/s12-967d669a7c1688db0c0a9e84e6625dbd.jpg";